import React, { useState, useEffect } from "react";
import { Card, Button, Tag, Typography, Row, Col, Space, Divider, Spin, message, Steps, Select, Form, Tooltip } from "antd";
import { applicationStatus } from "../../constants/DataConstants";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import { useLocation } from "react-router-dom";
import _NewapplicationService from "../../modules/NewapplicationService";
import _commonService from "../../modules/commonService";
import { UserOutlined, DollarOutlined, UpCircleFilled, DownCircleFilled, ClockCircleOutlined, CreditCardOutlined, DollarCircleOutlined, WalletOutlined, FileTextOutlined, ArrowRightOutlined, SyncOutlined } from "@ant-design/icons";
import MainLayout from "../pageHeader/MainLayout";
import { useHistory } from "react-router-dom";
import { routes } from "../../routes/Routes";
import StatusTag from "../../components/StatusTag";
import SidebarLayout from "../BankerUI/SidebarLayout";
import "../UserAccount/MyApplications.scss";
import DashboardCards from "../NewApplication/ApplicantDashboardCard";
import DashboardPortfolio from "../NewApplication/ApplicantDashboardPortfolio";


const { Text, Title } = Typography;
const { Option } = Select;
const { Step } = Steps;
export default function MyApplications() {
  const [expandedIndex, setExpandedIndex] = useState(2);
  const [applications, setApplications] = useState([]);
  const [remarks, setRemarks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [bankNames, setBankNames] = useState([]);
  const location = useLocation();
  const history = useHistory();
  const bankadminIdRaw = localStorage.getItem("BankAdminId");
  const BankAdminID = bankadminIdRaw ? parseInt(bankadminIdRaw) : null;

  let data = location.state;
  let emailId = "";
  if (data && data.email) {
    emailId = data.email;
  }
  const [form] = Form.useForm();

  const [email] = useState(emailId ? emailId : localStorage.getItem("ApplicationEmailId"));
  const [BankAdminId, setBankAdminID] = useState(BankAdminID);
  const [IsFirmAdminFlag, setIsFirmAdminFlag] = useState(false);
  useEffect(() => {
    if (BankAdminId) {
      form.setFieldsValue({ role: BankAdminId });
    }

  }, [BankAdminId, form]);
  useEffect(() => {

  }, [IsFirmAdminFlag]);


  // useEffect(() => {
  //   getBankAdminListByEmail(email)
  // }, []);
  useEffect(() => {
    if (BankAdminId && email) {
      getApplicationsByEmailId(email, BankAdminId);
    }
  }, [BankAdminId, email]);
  useEffect(() => {
    const handleBankAdminIdChange = (e) => {
      const newId = e.detail.newId;
      setBankAdminID(newId);
    };

    window.addEventListener("BankAdminIdChanged", handleBankAdminIdChange);

    return () => {
      window.removeEventListener("BankAdminIdChanged", handleBankAdminIdChange);
    };
  }, []);
  // useEffect(() => {
  //   getApplicationsByEmailId(email);
  // }, []);

  const getBankAdminListByEmail = async (email) => {
    setLoading(true);
    try {
      const res = await _NewapplicationService.getBankAdminListByEmail(email);
      if (res.data.IsSuccess) {
        setLoading(false);
        getApplicationsByEmailId(email, BankAdminId ?? res.data.Obj[0].Id);
        setBankNames(res.data.Obj);

      } else {
        setLoading(false);
        message.error(res.data.Message || COMMON_ERROR_MSG);
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }

  const getApplicationsByEmailId = async (email, ID) => {
    setLoading(true);
    try {
      // const res = await _NewapplicationService.getApplicationListByEmail(email);
      const res = await _NewapplicationService.getApplicantsByEmailAndBankAdmin(email, ID);
      if (res.data.IsSuccess) {
        setLoading(false);
        setApplications(res.data.Obj);
        const flag = res.data.Obj[0]?.IsFirmAdmin;
        localStorage.setItem("IsFirmAdminFlag", JSON.stringify(flag));
        setIsFirmAdminFlag(flag);
      } else {
        if (res.data.Message == "Applicant Not Found") {
          history.push(routes.registeredEmail.path);
          localStorage.clear();
          sessionStorage.clear();
        } else {
          setApplications([]);
          setLoading(false);
          localStorage.setItem("IsFirmAdminFlag", JSON.stringify(false));
          setIsFirmAdminFlag(false);
          message.error(res.data.Message || COMMON_ERROR_MSG);
        }

      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }

  const getReviewCommentByApplicationId = async (applicationId) => {
    setLoading(true);
    try {
      const res = await _NewapplicationService.getReviewCommentByApplicationId(applicationId);

      if (res.data.IsSuccess) {
        setLoading(false);
        // setRemarks(res.data.Obj);
        const filteredRemarks = res.data.Obj?.filter(
          (item) =>
            item.ReviewCommentsBy_BankerId > 0 ||
            item.ReviewCommentsBy_LoanOfficerId > 0 ||
            (item.ReviewCommentsBy_BankerId == null && item.ReviewCommentsBy_LoanOfficerId == null)
        );
        setRemarks(filteredRemarks);
      } else {
        setLoading(false);
        message.error(res.data.Message || COMMON_ERROR_MSG);
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }


  const applicationButtonClick = (appObj) => {
    console.log(appObj, "appobject");
    localStorage.setItem("Id", appObj && appObj.Id);
    localStorage.setItem("ApplicationObjId", appObj && appObj.Id);
    localStorage.setItem("ApplicationEmailId", appObj && appObj.Email);
    localStorage.setItem("ApplicationStatusId", appObj && appObj.Application_Status_Id);
    localStorage.setItem("ApplicationId", appObj && appObj.ApplicationId);
    localStorage.setItem("RoleId", appObj && appObj.RoleId);

    localStorage.setItem("fromUserLoginScreen", true);
    localStorage.setItem("fromBalanceSheetScreen", false);
    localStorage.setItem("applicationTypeId", appObj.App_Det_Application_Type_Id);
    localStorage.setItem("isFromMyApplicationsList", true);
    localStorage.setItem("IsQuestionairCompleted",appObj.IsQuestionairCompleted)
    localStorage.setItem("isAllStepsCompleted", JSON.stringify(appObj.IsAllStepsCompleted ?? false));
    localStorage.setItem("SponserIdForFirmLogin", appObj.SponserId);
    history.push({
      pathname: appObj && appObj.IsAllStepsCompleted ? routes.dashboard.path : routes.ApplicantsDetails.path,
      state: { email: email, applicationData: appObj },
    }
    )
  }

  const uniqueRemarks = remarks?.reduce((acc, curr, index) => {
    if (index === 0 || curr.ApplicationStatusId !== remarks[index - 1].ApplicationStatusId) {
      acc.push(curr);
    }
    return acc;
  }, []);

  // Always render a fixed 5-stage vertical timeline (Draft, Document Upload, Submitted,
  // In Loan Review, <final outcome>), the same grouping approach used on the Application
  // Status tab, adapted to this API's field names (ApplicationStaus / ReviewCommentDate).
  // Stages not yet reached are rendered as hollow placeholders; the API response itself
  // is untouched. The 5th stage's title is driven entirely by the API response: it
  // defaults to "Approved" as a placeholder until the applicant's current status is
  // actually one of the final outcomes, at which point it switches to whatever the API
  // returned (Approved / Rejected / Declined).
  const FINAL_OUTCOME_TITLES = ["Approved", "Rejected", "Declined"];
  const NEGATIVE_STATUS_TITLES = ["Action Required", "Rejected", "Declined"];
  const STANDALONE_STEP_TITLES = ["Draft", "Document Upload", "Submitted", ...FINAL_OUTCOME_TITLES];

  const groupRemarksForDisplay = (items) => {
    if (!items || items.length === 0) return [];
    const grouped = [];
    let buffer = [];

    const flushBuffer = () => {
      if (buffer.length > 0) {
        const lastBufferedItem = buffer[buffer.length - 1];
        grouped.push({
          isGroup: true,
          ApplicationStaus: "In Loan Review",
          ReviewCommentDate: lastBufferedItem.ReviewCommentDate,
          items: buffer,
        });
        buffer = [];
      }
    };

    items.forEach((item) => {
      if (STANDALONE_STEP_TITLES.includes(item.ApplicationStaus)) {
        flushBuffer();
        grouped.push({ isGroup: false, ...item });
      } else {
        buffer.push(item);
      }
    });
    flushBuffer();

    return grouped;
  };

  const groupedRemarkSteps = groupRemarksForDisplay(uniqueRemarks);

  const lastGroupedRemarkStep = groupedRemarkSteps.length > 0 ? groupedRemarkSteps[groupedRemarkSteps.length - 1] : null;
  const finalOutcomeTitle =
    lastGroupedRemarkStep && FINAL_OUTCOME_TITLES.includes(lastGroupedRemarkStep.ApplicationStaus)
      ? lastGroupedRemarkStep.ApplicationStaus
      : "Approved";

  const ALL_STAGE_TITLES = ["Draft", "Document Upload", "Submitted", "In Loan Review", finalOutcomeTitle];

  const currentStageIndex = lastGroupedRemarkStep ? ALL_STAGE_TITLES.indexOf(lastGroupedRemarkStep.ApplicationStaus) : -1;
  const isFinalStage = currentStageIndex === ALL_STAGE_TITLES.length - 1;

  const fixedRemarkStages = ALL_STAGE_TITLES.map((title, idx) => {
    const matched = groupedRemarkSteps.find((s) => s.ApplicationStaus === title);

    let stageState = "wait";
    if (currentStageIndex !== -1) {
      if (idx < currentStageIndex) stageState = "finish";
      else if (idx === currentStageIndex) stageState = isFinalStage ? "finish" : "process";
    }

    const lastItem = matched?.isGroup ? matched.items[matched.items.length - 1] : matched;
    const isNegativeOutcome =
      idx === currentStageIndex && !!lastItem && NEGATIVE_STATUS_TITLES.includes(lastItem.ApplicationStaus);

    return {
      isGroup: false,
      ApplicationStaus: title,
      ...matched,
      stageState,
      isNegativeOutcome,
    };
  });

  const currentStageTitle = currentStageIndex >= 0 ? ALL_STAGE_TITLES[currentStageIndex] : null;

  const renderStageDot = (status) => {
    let background = "transparent";
    let border = "#8c8c8c";
    if (status === "finish") {
      background = "#00E3C4";
      border = "#00E3C4";
    } else if (status === "process") {
      border = "#FAAD14";
    } else if (status === "error") {
      background = "red";
      border = "red";
    }
    return (
      <span
        style={{
          display: "inline-block",
          width: 10,
          height: 10,
          borderRadius: "50%",
          backgroundColor: background,
          border: `2px solid ${border}`,
          boxSizing: "border-box",
        }}
      />
    );
  };

  const stepItems = fixedRemarkStages.map((step) => {
    const lastItem = step.isGroup ? step.items[step.items.length - 1] : step;
    const isNegativeOutcome = step.isNegativeOutcome;

    const titleNode = (
      <Text
        strong
        style={{
          color: isNegativeOutcome
            ? "red"
            : step.stageState === "wait"
              ? "#999"
              : step.stageState === "process"
                ? "#FAAD14"
                : "#00E3C4",
        }}
      >
        {step.ApplicationStaus}
      </Text>
    );

    let descriptionNode;
    if (step.stageState === "wait") {
      descriptionNode = <div style={{ color: "#7A869A", fontSize: 14 }}>Remaining</div>;
    } else if (step.stageState === "process") {
      descriptionNode = (
        <div style={{ color: "#7A869A", fontSize: 14 }}>
          {isNegativeOutcome ? lastItem?.ApplicationStaus : "In progress"}
        </div>
      );
    } else if (step.ApplicationStatusId === 5) {
      descriptionNode = (
        <div className="consumer-dashboard-steps">
          <div style={{ color: "#7A869A", fontSize: 14, marginBottom: 4 }} className="displayNone">
            <Text strong>Remarks:</Text> {step.Remarks || "N/A"}
          </div>
          <div style={{ color: "#7A869A", fontSize: 14, marginBottom: 4 }}>
            <Text strong>Comments:</Text> {step.Comments || "N/A"}
          </div>
          <div style={{ color: "#7A869A", fontSize: 14 }}>
            <Text strong>Date & Time:</Text>{" "}
            {step.ReviewCommentDate ? _commonService.formatDateTimeAMPM(step.ReviewCommentDate) : "N/A"}
          </div>
        </div>
      );
    } else {
      descriptionNode = (
        <div style={{ color: "#7A869A", fontSize: 14 }}>
          <Text strong>Date & Time:</Text>{" "}
          {step.ReviewCommentDate ? _commonService.formatDateTimeAMPM(step.ReviewCommentDate) : "N/A"}
        </div>
      );
    }

    return {
      title: step.isGroup ? (
        <Tooltip
          overlayStyle={{ maxWidth: "none" }}
          overlayInnerStyle={{ padding: 16 }}
          title={
            <Steps
              size="small"
              labelPlacement="vertical"
              className="applicationStatusTimeline"
              style={{ minWidth: step.items.length * 130 }}
            >
              {step.items.map((item, itemIndex) => (
                <Step
                  key={itemIndex}
                  title={
                    <Text strong style={{ color: "#00E3C4" }}>
                      {item.ApplicationStaus}
                    </Text>
                  }
                  description={
                    <Text type="secondary">
                      {item.ReviewCommentDate ? _commonService.formatDateTimeAMPM(item.ReviewCommentDate) : "N/A"}
                    </Text>
                  }
                  status="finish"
                />
              ))}
            </Steps>
          }
        >
          <div>{titleNode}</div>
        </Tooltip>
      ) : (
        titleNode
      ),
      description: descriptionNode,
      status: isNegativeOutcome ? "error" : step.stageState,
    };
  });

  // const handleChange = (value) => {
  //   getApplicationsByEmailId(email, value);

  // }

  return (
    <Spin spinning={loading}>
      <SidebarLayout>
        <Title level={2}>Dashboard</Title>
        <div style={{ minHeight: "100vh" }}>
          <DashboardCards />
          <div>
            <Row justify="space-between" align="middle">
              {/* Left Side - Title + Email */}
              <Col>
                <Title level={4} className="title mt20">
                  My Applications
                </Title>
                <Text
                  type="secondary"
                  className="my-applications-email"
                >
                  <UserOutlined style={{ marginRight: 7 }} />
                  {email}
                </Text>
              </Col>
            </Row>

            {applications && applications.map((app, idx) => (
              <Card
                key={idx}
                className="my-applications-consumer-dashboard"
              >
                <div>

                  <Row gutter={[0, 5]}>
                    <Col span={24}>
                      <div className="alignAppDiv">
                        <div className="alignAppDiv1">
                          <StatusTag statusId={app.Application_Status_Id} />
                          <Text
                            type="secondary"
                            className="applicationsText"
                          >
                            <ClockCircleOutlined style={{ marginRight: 4 }} />
                            Last Activity: {app.UpdatedDate ? _commonService.formatDateTimeAMPM(app.UpdatedDate) : "N/A"}
                          </Text>
                        </div>
                        <div>
                          <Button
                            type="link"
                            className="butn"
                            onClick={() => applicationButtonClick(app)}
                          >
                            {applicationStatus && applicationStatus.find(status => status.id === app.Application_Status_Id)?.buttonName}
                            <ArrowRightOutlined style={{ marginLeft: 5 }} />
                          </Button>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row align="middle" justify="space-between" wrap gutter={[0, 5]} style={{ marginTop: 18 }}>
                    <Col xs={24} sm={20}>
                      <Space size={32} wrap>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <FileTextOutlined style={{ color: "#B1B9C8", fontSize: 18 }} />
                          <Text className="applicationsText">{app.ApplicationId}</Text>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <UserOutlined style={{ color: "#B1B9C8", fontSize: 18 }} />
                          <Text className="applicationsText">
                            {app.App_Det_FirstName || "N/A"} {app.App_Det_LastName}
                          </Text>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <DollarOutlined style={{ color: "#B1B9C8", fontSize: 18 }} />
                          <Text className="applicationsText">
                            {app && app.App_Det_LoanAmount ? `$ ${_commonService.formatNumberWithCommas(app.App_Det_LoanAmount)}` : "N/A"}
                          </Text>
                        </div>
                        <div>
                          {app.IsRemarksCommentsAvailable && (
                            <Col span={1}>
                              <Button
                                type="text"
                                // className="expand-btn"

                                icon={
                                  expandedIndex === idx ? (
                                    <UpCircleFilled style={{ fontSize: 20 }} />
                                  ) : (
                                    <DownCircleFilled style={{ fontSize: 20 }} />
                                  )
                                }
                                onClick={() => {
                                  setExpandedIndex(expandedIndex === idx ? null : idx);
                                  getReviewCommentByApplicationId(app.Id);
                                }}

                                aria-label={expandedIndex === idx ? "Collapse" : "Expand"}
                              />
                            </Col>
                          )}

                        </div>
                      </Space>
                    </Col>
                  </Row>
                </div>
                {expandedIndex === idx && app.expandedContent && (
                  <Divider
                    style={{
                      margin: 0,
                      borderColor: "#E7EAF3",
                    }}
                  />
                )}

                {expandedIndex === idx && remarks && remarks.length > 0 &&
                  <>
                    <Divider className="mb10 mt10" />
                    {currentStageTitle && (
                      <div style={{ marginBottom: 10 }}>
                        <Text type="secondary">
                          Status: <Text strong>{currentStageTitle}</Text> &middot; Step {currentStageIndex + 1} of {ALL_STAGE_TITLES.length}
                        </Text>
                      </div>
                    )}
                    <Steps
                      className="progressbardiv"
                      progressDot={(_iconDot, { status }) => renderStageDot(status)}
                      direction="vertical"
                      current={currentStageIndex >= 0 ? currentStageIndex : 0} // Highlight the current stage
                      items={stepItems}
                    />
                  </>
                }
              </Card>
            ))}
          </div>
          <div className='mt20'>
            <DashboardPortfolio />
          </div>
        </div>
      </SidebarLayout>
    </Spin>
  );
}